import React, { MouseEventHandler, ReactNode } from 'react';
import {
  LinkTrackingParams,
  ExperienceData,
  appendTrackingParamsToUrl,
} from 'utils/linkTracking';

type CatchLinkWrapperProps = {
  children: ReactNode;
  onLinkClick: (href: string) => void;
  linkTrackingParams?: LinkTrackingParams | null;
  experienceData?: ExperienceData | null;
};

const CatchLinkWrapper: React.FC<CatchLinkWrapperProps> = ({
  children,
  onLinkClick,
  linkTrackingParams,
  experienceData,
}) => {
  const getTrackedUrl = (href: string): string => {
    if (!linkTrackingParams?.enabled || !experienceData) {
      return href;
    }
    return appendTrackingParamsToUrl(href, linkTrackingParams, experienceData);
  };

  const catchEvents: MouseEventHandler<HTMLDivElement> = (e) => {
    const element = e.target as HTMLAnchorElement;
    if (element.tagName === 'A') {
      const originalHref = element.href;
      const trackedHref = getTrackedUrl(originalHref);

      // Update the href with tracking params before navigation
      if (trackedHref !== originalHref) {
        element.href = trackedHref;
      }

      onLinkClick(trackedHref);
      return;
    }
    const parentAnchor = element?.parentElement?.closest('a');
    if (parentAnchor) {
      const originalHref = parentAnchor.href;
      const trackedHref = getTrackedUrl(originalHref);

      // Update the href with tracking params before navigation
      if (trackedHref !== originalHref) {
        parentAnchor.href = trackedHref;
      }

      onLinkClick(trackedHref);
      return;
    }
  };

  return <div onClick={catchEvents}>{children}</div>;
};

export default CatchLinkWrapper;
